import { Stack } from '@mui/material';

import { ViewTitleBar } from '@@components';

type RuleSetListViewProps = {};

export default function RuleSetListView({}: RuleSetListViewProps) {
	return (
		<Stack direction="column" sx={{ flexGrow: 1 }}>
			<ViewTitleBar title="Rules" />
		</Stack>
	);
}
